/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, portal: NonNullable<unknown> }} Pm_Confirm_BodyInputs */

const cs_pm_confirm_body = /** @type {(inputs: Pm_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uložíme ${i?.n} ID inzerátů z portálu ${i?.portal} k nemovitostem. Na portál se nic neodešle; nové exporty zůstanou vypnuté.`)
};

const en_pm_confirm_body = /** @type {(inputs: Pm_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We'll save ${i?.n} listing IDs from ${i?.portal} to properties. Nothing is sent to the portal; new exports stay disabled.`)
};

/**
* | output |
* | --- |
* | "We'll save {n} listing IDs from {portal} to properties. Nothing is sent to the portal; new exports stay disabled." |
*
* @param {Pm_Confirm_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_confirm_body = /** @type {((inputs: Pm_Confirm_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Confirm_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_confirm_body(inputs)
	return cs_pm_confirm_body(inputs)
});